// extracted by mini-css-extract-plugin
module.exports = {"divider":"AttachmentAddPopup_divider__19gxT","menu":"AttachmentAddPopup_menu__3nCN1","menuItem":"AttachmentAddPopup_menuItem__3kxMp","tip":"AttachmentAddPopup_tip__3qK5h"};